import {createFileRoute, SearchSchemaInput} from '@tanstack/react-router'

import EventQuizFlow from '../eventQuiz/EventQuizFlow.tsx'
import {eventQuizOn, useSports} from '../sports/registry.ts'

/**
 * The one-off event flow: reached from the home page's "describe your event" box (the text is
 * handed over in sessionStorage) or with ?start=questions to answer questions instead. Behind
 * event_quiz_enabled: while it is off the server 404s the flow's endpoints, so the page sends the
 * organizer to the normal signup.
 */
export const Route = createFileRoute('/event-quiz')({
    validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
        start: search.start === 'questions' ? 'questions' as const : search.start === 'describe' ? 'describe' as const : undefined,
    }),
    component: EventQuizPage,
    head: () => ({meta: [{title: 'Create your event | ScorePal'}, {name: 'robots', content: 'noindex'}]}),
})

function EventQuizPage() {
    const {start} = Route.useSearch()
    const {data: registry} = useSports()

    if (!eventQuizOn(registry)) {
        return (
            <div className="grid min-h-screen place-items-center bg-[#f5f9ff] px-4 text-center">
                <div>
                    <h1 className="text-2xl font-extrabold text-[#0a1b60]">Create your event</h1>
                    <a href="/signup/player/" className="mt-4 inline-block rounded-full bg-[#0969f4] px-6 py-3 font-semibold text-white">Get started free</a>
                </div>
            </div>
        )
    }

    return <EventQuizFlow start={start} />
}
